var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-play"},[_c('img',{staticClass:"video-play_icon",attrs:{"src":require("../../assets/img/video_close.png"),"alt":""},on:{"click":_vm.playerClose}}),_c('video',{attrs:{"controls":"","src":_vm.videoSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }